import { areUrlsEqualish } from 'omni-ui';

export function updateLocation({
  client,
  campaign,
  stage,
  step,
  setParams,
  deleteParams,
}) {
  const url = new URL(window.location);

  // Set search parameters
  if (setParams) {
    Object.entries(setParams).forEach(([key, value]) =>
      url.searchParams.set(key, value),
    );
  }

  // Delete search parameters
  if (deleteParams) {
    deleteParams.forEach(key => url.searchParams.delete(key));
  }

  // Update url if step, stage, campaign, or client are provided
  if (step) {
    url.pathname = `/${client}/campaigns/${campaign}/steps/${step}`;
  } else if (stage) {
    url.pathname = `/${client}/campaigns/${campaign}/stages/${stage}`;
  } else if (campaign) {
    url.pathname = `/${client}/campaigns/${campaign}`;
  }

  // Set new url if there was a change
  if (!areUrlsEqualish(window.location, url)) {
    window.history.pushState(null, '', url);
    window.dispatchEvent(new PopStateEvent('popstate'));
  }
}
